import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { RouterOutlet } from '@angular/router'
import { OidcSecurityService } from 'angular-auth-oidc-client'
import { MessageService } from 'primeng/api'
import { ToastModule } from 'primeng/toast'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  providers: [MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly oidcSecurityService = inject(OidcSecurityService)

  constructor() {
    this.oidcSecurityService.checkAuth().pipe(takeUntilDestroyed()).subscribe()
  }
}
